export default {
  name: "XcpGameManager",
  computed: {
    key: function key() {
      return this.$route.fullPath;
    }
  }
};